import { useCallback } from 'react';
import { useImportDateFnsLocale } from '@elfsight/widget-utils';
import { format } from 'date-fns-tz';
import { useBusinessHoursProps } from '../../business-hours-props-context';

export const useDateFormatter = () => {
  const { timeZone, language, dayMonthFormat } = useBusinessHoursProps();
  const localeCode = language?.language ?? 'en';
  const locale = useImportDateFnsLocale(localeCode);

  return useCallback(
    (date: Date) => {
      const localeDateString = date.toLocaleDateString(localeCode, {
        day: 'numeric',
        month: 'short'
      });
      const dayOnly = date.toLocaleDateString(localeCode, {
        day: 'numeric'
      });
      const isDayBeforeMonth = localeDateString.indexOf(dayOnly) === 0;
      const monthTemplate = dayMonthFormat === 'full' ? 'MMMM' : 'MMM';

      const formatType = isDayBeforeMonth
        ? `d ${monthTemplate}`
        : `${monthTemplate} d`;

      return format(date, formatType, { locale });
    },
    [dayMonthFormat, timeZone, locale]
  );
};
